import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// META PIXEL (Prime Wellness Pixel)
(function initMetaPixel() {
  // Evita duplicarlo si React recarga / hot reload
  if ((window as any).fbq) return;
  const script = document.createElement("script");
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '869439375938828');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
})();
render(<App data-id="element-1" />, document.getElementById("root"));